import { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Menu, X, Phone, Mail, MapPin, Car, Users, Briefcase, UserPlus,
  Wrench, Calculator, Instagram, Linkedin, CalendarDays, ShieldCheck, ArrowRight
} from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LOGO = 'https://customer-assets.emergentagent.com/job_cce403d0-b00f-43d3-9a84-931509907efe/artifacts/ipyjeard_National%20Mobility%20Logo.jpeg';
const IMRAN = 'https://customer-assets.emergentagent.com/job_cce403d0-b00f-43d3-9a84-931509907efe/artifacts/3888yf1x_Imran%20Bhai%20Full-clean.png';
const SHAHBAZ = 'https://customer-assets.emergentagent.com/job_cce403d0-b00f-43d3-9a84-931509907efe/artifacts/a4wcv4kc_Shahbaz%20PP.jpeg';
const HERO_BG = 'https://static.prod-images.emergentagent.com/jobs/cce403d0-b00f-43d3-9a84-931509907efe/images/4ebf409e6db2f1f34fc6f9e7a59ca1b1f9c157dd956adc04d12347b6735ba34e.png';
const WAGON_R = 'https://static.prod-images.emergentagent.com/jobs/cce403d0-b00f-43d3-9a84-931509907efe/images/8b4bdf4a5e7b05fddc1977992c1bd327e8901466791df9866bd9150867acc61a.png';
const RUMION = 'https://static.prod-images.emergentagent.com/jobs/cce403d0-b00f-43d3-9a84-931509907efe/images/e9d8ecd4b77391d5e106c718e4e309bddea03eaf25e8b8f6455f00a4c6eb8e0c.png';

const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '#about' },
  { label: 'Our Services', href: '#services' },
  { label: 'Contact Us', href: '#contact' },
];

const SERVICES = [
  { icon: CalendarDays, title: 'Daily Leasing', desc: 'Flexible daily lease plans on well-maintained commercial vehicles — drive today, earn today.' },
  { icon: Car, title: 'Ride-Hailing Fleet', desc: 'Uber & Ola ready vehicles with commercial permits, so drivers can start earning immediately.' },
  { icon: Briefcase, title: 'Corporate Transport', desc: 'Reliable employee transportation solutions for businesses, with professional drivers.' },
  { icon: UserPlus, title: 'Driver Onboarding', desc: 'Fast, structured onboarding with document verification and dedicated support.' },
  { icon: Wrench, title: 'Repair & Maintenance', desc: 'In-house R&M tracking keeps every vehicle serviced, safe and road-ready.' },
  { icon: Calculator, title: 'Accounts Management', desc: 'Transparent weekly hisaab, payments and ledgers — every rupee accounted for.' },
];

const FLEET = [
  {
    name: 'Maruti Suzuki Wagon R', tag: 'Commercial', img: WAGON_R,
    desc: 'The most trusted workhorse for ride-hailing. Compact, efficient and CNG-ready — the perfect earning partner for Uber & Ola drivers.',
    specs: ['CNG + Petrol', '5 Seater', 'Best-in-class Mileage'],
  },
  {
    name: 'Toyota Rumion', tag: 'Premium MPV', img: RUMION,
    desc: 'Spacious 7-seater MPV built for corporate employee transportation and premium ride-hailing. Comfort, safety and Toyota reliability.',
    specs: ['7 Seater', 'Corporate Ready', 'Toyota Reliability'],
  },
];

const FOUNDERS = [
  { name: 'Imran Hajwani', designation: 'Founder & CEO', photo: IMRAN },
  { name: 'Shaikh Shahbaz', designation: 'COO', photo: SHAHBAZ },
];

const SOCIALS = [
  { icon: Instagram, href: 'https://www.instagram.com/nationalmobility/', label: 'Instagram' },
  { icon: Linkedin, href: 'https://www.linkedin.com/company/national-mobility/', label: 'LinkedIn' },
];

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" fill="currentColor" className={className}>
    <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.59 4.46 1.71 6.4L3.2 28.8l6.58-1.67a12.74 12.74 0 0 0 6.22 1.6h.01c7.06 0 12.79-5.74 12.79-12.8 0-3.42-1.33-6.63-3.75-9.05a12.72 12.72 0 0 0-9.05-3.68zm0 23.36h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4.02 1.02 1.07-3.92-.25-.4a10.57 10.57 0 0 1-1.63-5.66c0-5.87 4.78-10.64 10.65-10.64 2.84 0 5.51 1.11 7.52 3.12a10.57 10.57 0 0 1 3.11 7.53c0 5.87-4.78 10.66-10.65 10.66zm5.84-7.97c-.32-.16-1.89-.93-2.19-1.04-.29-.11-.5-.16-.72.16-.21.32-.82 1.04-1.01 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55l-.61-.01c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66 0 1.57 1.14 3.08 1.3 3.29.16.21 2.25 3.43 5.45 4.81.76.33 1.36.53 1.82.67.77.24 1.46.21 2.01.13.61-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37z" />
  </svg>
);

export default function LandingPage() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [team, setTeam] = useState([]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/public/team`)
      .then((res) => setTeam(Array.isArray(res.data) ? res.data : []))
      .catch(() => setTeam([]));
  }, []);

  const scrollTo = (href) => {
    setMenuOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A]" style={{ fontFamily: "'Manrope', sans-serif" }} data-testid="landing-page">
      {/* Header */}
      <header className={`fixed top-0 inset-x-0 z-50 transition-all backdrop-blur-xl ${scrolled ? 'bg-white/90 shadow-sm border-b border-slate-200' : 'bg-white/70'}`} data-testid="landing-header">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-16">
          <button onClick={() => scrollTo('#home')} className="flex items-center gap-2" data-testid="landing-logo">
            <img src={LOGO} alt="National Mobility" className="h-10 w-auto rounded" />
          </button>
          <nav className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((l) => (
              <button key={l.label} onClick={() => scrollTo(l.href)}
                className="text-sm font-semibold text-slate-600 hover:text-[#2196F3] transition-colors"
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, '-')}`}>
                {l.label}
              </button>
            ))}
            <a href="/login" target="_blank" rel="noopener noreferrer"
              className="bg-[#2196F3] hover:bg-[#1E88E5] text-white rounded-lg px-5 py-2.5 text-sm font-semibold transition-all shadow-sm hover:shadow-md"
              data-testid="employee-login-btn">
              Employee Login
            </a>
          </nav>
          <button className="md:hidden p-2" onClick={() => setMenuOpen(!menuOpen)} data-testid="mobile-menu-btn">
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        {menuOpen && (
          <div className="md:hidden bg-white border-t border-slate-200 px-6 py-4 space-y-3" data-testid="mobile-menu">
            {NAV_LINKS.map((l) => (
              <button key={l.label} onClick={() => scrollTo(l.href)} className="block w-full text-left text-sm font-semibold text-slate-700 py-2">
                {l.label}
              </button>
            ))}
            <a href="/login" target="_blank" rel="noopener noreferrer"
              className="block text-center bg-[#2196F3] text-white rounded-lg px-5 py-2.5 text-sm font-semibold"
              data-testid="mobile-employee-login-btn">
              Employee Login
            </a>
          </div>
        )}
      </header>

      {/* Hero */}
      <section id="home" className="relative min-h-[92vh] flex items-center" data-testid="hero-section">
        <div className="absolute inset-0">
          <img src={HERO_BG} alt="National Mobility Fleet" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-32 w-full">
          <div className="max-w-2xl">
            <span className="inline-block bg-[#2196F3]/20 backdrop-blur-sm border border-[#2196F3]/40 text-blue-200 text-xs font-bold tracking-widest uppercase rounded-full px-4 py-1.5 mb-6">
              Fleet Leasing · Mumbai
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-tight" style={{ fontFamily: "'Outfit', sans-serif" }} data-testid="hero-headline">
              Driving Mobility.<br />
              <span className="text-[#4FC3F7]">Delivering Trust.</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-slate-200 max-w-xl">
              Fleet leasing made simple for drivers and businesses. Wagon R & Toyota Rumion on daily leasing and rental — for ride-hailing partners and corporate transportation.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <button onClick={() => scrollTo('#fleet')}
                className="bg-[#2196F3] hover:bg-[#1E88E5] text-white rounded-lg px-7 py-3.5 font-semibold transition-all shadow-lg hover:shadow-xl flex items-center gap-2"
                data-testid="hero-explore-fleet-btn">
                Explore Our Fleet <ArrowRight className="w-4 h-4" />
              </button>
              <button onClick={() => scrollTo('#contact')}
                className="bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white rounded-lg px-7 py-3.5 font-semibold transition-all"
                data-testid="hero-contact-btn">
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* About */}
      <section id="about" className="py-24" data-testid="about-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-[#2196F3] text-xs font-bold tracking-widest uppercase">About Us</span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Powering the drivers and businesses that keep Mumbai moving
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed">
              National Mobility is a fleet leasing company built for the ride-hailing economy. We provide
              commercial-ready Maruti Suzuki Wagon R and Toyota Rumion vehicles on flexible daily leasing
              and rental models — helping Uber & Ola driver-partners earn without ownership burden, and
              helping corporates move their employees reliably.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-6">
              {[
                { icon: Car, label: 'Daily Leasing & Rental Models' },
                { icon: Users, label: 'Uber / Ola Driver Partners' },
                { icon: Briefcase, label: 'Corporate Employee Transport' },
                { icon: ShieldCheck, label: 'Fully Managed & Maintained Fleet' },
              ].map((f) => (
                <div key={f.label} className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
                    <f.icon className="w-5 h-5 text-[#2196F3]" />
                  </div>
                  <span className="text-sm font-semibold text-slate-700 pt-2">{f.label}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <img src={WAGON_R} alt="Fleet vehicle" className="rounded-2xl shadow-xl w-full object-cover" />
            <div className="absolute -bottom-6 -left-6 bg-[#1F2937] text-white rounded-2xl px-6 py-5 shadow-xl hidden sm:block">
              <p className="text-3xl font-bold" style={{ fontFamily: "'Outfit', sans-serif" }}>2</p>
              <p className="text-xs text-slate-300 font-semibold uppercase tracking-wide">Business Models<br />Lease & Rental</p>
            </div>
          </div>
        </div>
      </section>

      {/* Fleet */}
      <section id="fleet" className="py-24 bg-white" data-testid="fleet-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-[#2196F3] text-xs font-bold tracking-widest uppercase">Our Fleet</span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Two vehicles. Every use case covered.
            </h2>
          </div>
          <div className="mt-14 grid md:grid-cols-2 gap-8">
            {FLEET.map((car) => (
              <div key={car.name} className="bg-[#F8FAFC] rounded-2xl border border-slate-100 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden group" data-testid={`fleet-card-${car.name.toLowerCase().replace(/\s/g, '-')}`}>
                <div className="overflow-hidden h-64">
                  <img src={car.img} alt={car.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-8">
                  <span className="text-xs font-bold uppercase tracking-widest text-[#2196F3]">{car.tag}</span>
                  <h3 className="mt-2 text-xl sm:text-2xl font-semibold" style={{ fontFamily: "'Outfit', sans-serif" }}>{car.name}</h3>
                  <p className="mt-3 text-slate-600 text-sm leading-relaxed">{car.desc}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {car.specs.map((s) => (
                      <span key={s} className="bg-white border border-slate-200 rounded-full px-3 py-1 text-xs font-semibold text-slate-600">{s}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services */}
      <section id="services" className="py-24" data-testid="services-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-[#2196F3] text-xs font-bold tracking-widest uppercase">Our Services</span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
              End-to-end fleet operations, under one roof
            </h2>
          </div>
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {SERVICES.map((s) => (
              <div key={s.title} className="bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 p-8" data-testid={`service-card-${s.title.toLowerCase().replace(/\s|&/g, '-')}`}>
                <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center">
                  <s.icon className="w-6 h-6 text-[#2196F3]" />
                </div>
                <h3 className="mt-5 text-lg font-semibold" style={{ fontFamily: "'Outfit', sans-serif" }}>{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section id="team" className="py-24 bg-[#1F2937]" data-testid="team-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-[#4FC3F7] text-xs font-bold tracking-widest uppercase">Our Team</span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
              The people behind National Mobility
            </h2>
          </div>

          {/* Founders */}
          <div className="mt-14 grid sm:grid-cols-2 gap-8 max-w-3xl mx-auto">
            {FOUNDERS.map((f) => (
              <div key={f.name} className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden hover:bg-white/10 transition-all duration-300 group" data-testid={`founder-card-${f.name.toLowerCase().replace(/\s/g, '-')}`}>
                <div className="h-80 overflow-hidden bg-slate-800">
                  <img src={f.photo} alt={f.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-lg font-semibold text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>{f.name}</h3>
                  <p className="mt-1 text-sm font-semibold text-[#4FC3F7]">{f.designation}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Dynamic employees */}
          {team.length > 0 && (
            <div className="mt-16" data-testid="dynamic-team-grid">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
                {team.map((m, i) => (
                  <div key={i} className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden hover:bg-white/10 transition-all duration-300" data-testid={`team-member-card-${i}`}>
                    <div className="h-48 bg-slate-800 flex items-center justify-center overflow-hidden">
                      {m.photo_url ? (
                        <img src={m.photo_url} alt={m.name} className="w-full h-full object-cover object-top" />
                      ) : (
                        <Users className="w-12 h-12 text-slate-600" />
                      )}
                    </div>
                    <div className="p-4 text-center">
                      <h4 className="text-sm font-semibold text-white truncate">{m.name}</h4>
                      <p className="mt-0.5 text-xs font-semibold text-[#4FC3F7] truncate">{m.designation || 'Team Member'}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="py-24 bg-white" data-testid="contact-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-[#2196F3] text-xs font-bold tracking-widest uppercase">Contact Us</span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Let's get you on the road
            </h2>
          </div>
          <div className="mt-14 grid lg:grid-cols-2 gap-10">
            <div className="space-y-6">
              {[
                { icon: MapPin, title: 'Address', value: '1B-80, Phoenix Paragon Plaza, LBS Marg, Kurla, Mumbai - 400070', href: null },
                { icon: Phone, title: 'Phone', value: '+91 90822 74858', href: 'tel:+919082274858' },
                { icon: Mail, title: 'Email', value: 'nationalmobility3@gmail.com', href: 'mailto:nationalmobility3@gmail.com' },
              ].map((c) => (
                <div key={c.title} className="flex items-start gap-4 bg-[#F8FAFC] border border-slate-100 rounded-2xl p-6" data-testid={`contact-${c.title.toLowerCase()}`}>
                  <div className="w-11 h-11 rounded-xl bg-blue-50 flex items-center justify-center shrink-0">
                    <c.icon className="w-5 h-5 text-[#2196F3]" />
                  </div>
                  <div>
                    <p className="text-xs font-bold uppercase tracking-widest text-slate-400">{c.title}</p>
                    {c.href ? (
                      <a href={c.href} className="mt-1 block font-semibold text-slate-800 hover:text-[#2196F3] transition-colors">{c.value}</a>
                    ) : (
                      <p className="mt-1 font-semibold text-slate-800">{c.value}</p>
                    )}
                  </div>
                </div>
              ))}
              <div className="flex items-center gap-4 pt-2">
                <span className="text-sm font-semibold text-slate-500">Follow us:</span>
                {SOCIALS.map((s) => (
                  <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-slate-100 hover:bg-[#2196F3] text-slate-600 hover:text-white flex items-center justify-center transition-all"
                    data-testid={`social-${s.label.toLowerCase()}`} title={s.label}>
                    <s.icon className="w-5 h-5" />
                  </a>
                ))}
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-sm min-h-[380px]" data-testid="google-map">
              <iframe
                title="National Mobility Office - Phoenix Paragon Plaza, Kurla"
                src="https://www.google.com/maps?q=Phoenix%20Paragon%20Plaza%2C%20LBS%20Marg%2C%20Kurla%2C%20Mumbai%20400070&output=embed"
                className="w-full h-full min-h-[380px]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0F172A] text-slate-400 py-10" data-testid="landing-footer">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm font-semibold">© {new Date().getFullYear()} National Mobility. All rights reserved.</p>
          <div className="flex items-center gap-3">
            {SOCIALS.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#2196F3] flex items-center justify-center transition-all hover:text-white"
                title={s.label}>
                <s.icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp */}
      <a href="https://wa.me/919082274858" target="_blank" rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20BD5A] text-white flex items-center justify-center shadow-lg hover:-translate-y-1 transition-transform"
        data-testid="whatsapp-float-btn" title="Chat on WhatsApp">
        <WhatsAppIcon className="w-8 h-8" />
      </a>
    </div>
  );
}
